import React from 'react';
import { TextComponent } from 'baseComponents/TextComponent';
import { Spin } from 'antd';
import 'baseComponents/IconStatsCardComponent/iconStatsCardComponent.scss';

interface Props {
  statsValue: string;
  title: string;
  subtitle?: string;
  iconType: string;
  creditWarning?: boolean;
}

export const IconStatsCardComponent: React.FC<Props> = (props) => {
  return (
    <div className='card-wrapper'>
      <img
        className='icon'
        src={props.iconType}
        alt='icon representing stats'
      />
      <TextComponent text={props.title} styleType='secondary' size='large' />
      {!props.statsValue ? (
        <Spin spinning size='small' />
      ) : (
        <TextComponent text={props.statsValue} size='extra-large' />
      )}

      {props.subtitle && (
        <TextComponent
          text={props.subtitle || ''}
          styleType='secondary'
          size='extra-small'
        />
      )}

      {props.creditWarning && props.title === 'Credit Balance' && (
        <TextComponent
          text={'⚠️ running low'}
          styleType='secondary'
          size='extra-small'
        />
      )}
    </div>
  );
};
